import Controller from "./reportGenerator.controller";
import template from "./reportGenerator.html";

const reportGenerator = {
  template,
  controller: Controller,
};

export default reportGenerator;



// WEBPACK FOOTER //
// ./src/pages/reportGenerator/reportGenerator.component.js